module.exports = __webpack_public_path__ + "img/easypay268x87.923d35c2.jpg";